import { ExistingDestination, Transfer } from "@prequel/react";

import axios, { ApiResponse, ApiRoutes, ID_PLACEHOLDER } from "@/api/client";
import { handleApiError } from "@/api/helpers";

const getTransferByID: (transferID: Transfer["id"]) => Promise<Transfer> = (transferID) =>
  axios
    .get(`${ApiRoutes.TRANSFERS}/${transferID}`)
    .then((response: ApiResponse<{ transfer: Transfer }>) => response.data.data.transfer)
    .catch(handleApiError("Failed to fetch transfer.", true));

const postTransfer: (p: {
  destinationID: ExistingDestination["id"];
  fullRefresh: boolean;
  models?: string[];
  startTransferWindowAt?: string;
  endTransferWindowAt?: string;
  tags?: Record<string, string>;
}) => Promise<{ destinationID: ExistingDestination["id"] }> = ({
  destinationID,
  fullRefresh,
  models,
  startTransferWindowAt,
  endTransferWindowAt,
  tags,
}) =>
  axios
    .post(`${ApiRoutes.DESTINATIONS}/${destinationID}${ApiRoutes.TRANSFER}`, {
      full_refresh: fullRefresh,
      models: models,
      start_transfer_window_at: startTransferWindowAt,
      end_transfer_window_at: endTransferWindowAt,
      tags: tags,
    })
    .then(() => ({
      destinationID,
    }))
    .catch(handleApiError("Transfer failed to enqueue."));

const cancelExportTransfer = (transferID: Transfer["id"]): Promise<void> => {
  const url = ApiRoutes.CANCEL_EXPORT_TRANSFER.replace(ID_PLACEHOLDER, transferID);
  return axios
    .post(url)
    .then(() => undefined)
    .catch(handleApiError("Transfer failed to cancel."));
};

const TransfersService = {
  cancelExportTransfer,
  postTransfer,
  getTransferByID,
};
export default TransfersService;
